/**
 * Finds the dashboard category id that contains a card with the given id.
 * @param {{ categories?: { id: string, cards?: { id: string }[] }[] }} layout
 * @param {string} cardId
 * @returns {string | null}
 */
export function findCategoryIdContainingCard(layout, cardId) {
	for (const cat of layout?.categories || []) {
		if ((cat.cards || []).some((c) => c.id === cardId)) return cat.id;
	}
	return null;
}
